module.exports =(function (value,default_val='') {
    if(typeof value==='undefined'|| value==null || value===''){
        return default_val;
    }else{
        return value.split('T')[0]+' '+value.split('T')[1].substring(0,8)
    }
    
    
})
